import {Component, OnInit, ViewChild, Inject, AfterViewInit, OnDestroy} from '@angular/core';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {Http} from '@angular/http';
import {APP_CONFIG, AppConfig} from '../config/app.config.module';
import {NavService} from '../header/nav/nav.service';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import {BreadcrumbService} from '../header/breadcrumb/breadcrumb.service';
import {ISubscription} from 'rxjs/Subscription';
import {TopnavService} from '../header/topnav/topnav.service';
import {DatePipe} from '@angular/common';
import {ToastrService} from '../../../node_modules/ngx-toastr';
import {SharedService} from '../common/shared.service';
import * as moment from 'moment-timezone';
import {OwlCarousel} from 'ng2-owl-carousel';

declare var google: any;

/**
 * Author: gomsmaasi
 *
 * Date Created: January 22 2018
 *
 * Description: Component class for Announcementbox.
 **/
@Component({
  selector: 'app-announcementbox',
  templateUrl: './announcementbox.component.html',
  styleUrls: ['./announcementbox.component.css']
})

export class AnnouncementboxComponent implements OnInit, AfterViewInit, OnDestroy {
  languageId: any;
  lang = 'en';
  announcementData: any;
  calendarData: any;
  announces: any;
  announceRes: any;
  breadcrumb: any;
  isValid: any;
  date = new Date();
  private announcementUrl: string = this.config.urlAnnouncement;
  private calendarUrl: string = this.config.urlCalendar;
  private subscription: ISubscription;
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;
  public fontSize: any = {
    "sizeS": "14px",
    "sizeM": "19px",
    "sizeL": "23px",
    "no_styles": "0.9em"
  };
  loading: boolean = false;

  public currentDateTime: string;
  //public surveyResult: number = 89;
  public resultFontSize: string = '60px';

  @ViewChild('owlElement') owlElement: OwlCarousel;

  private isInitialized: boolean = false;

  constructor(private sharedService: SharedService, private toastr: ToastrService, private translate: TranslateService,
              private http: Http,
              @Inject(APP_CONFIG) private config: AppConfig,
              private route: ActivatedRoute,
              private navService: NavService,
              private topnavservice: TopnavService,
              private datePipe: DatePipe,
              private breadcrumbService: BreadcrumbService,
              private router: Router
  ) {
    this.lang = translate.currentLang;
    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = translate.currentLang;
      if (myLang === 'en') {
        this.lang = 'en';
        this.languageId = 1;
      }
      if (myLang === 'ms') {
        this.lang = 'ms';
        this.languageId = 2;
      }

      if (this.topnavservice.flagLang && this.isInitialized) {
        this.getCalendarData(this.languageId);
        this.getData(this.languageId);
      }
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data) => {
      this.fontSize = data;
    });
  }

  ngOnInit() {

    this.currentDateTime = moment().format("YYYY-MM-DD") + ' 00:00:00';

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else {
        this.languageId = 1;
      }
    }

    this.getData(this.languageId);
    this.getCalendarData(this.languageId);

    //this.surveyResult = 80;
  }

  ngAfterViewInit() {
    /*google.charts.setOnLoadCallback(()=> {
      drawChart(this.surveyResult);
    });
    function drawChart(result) {

      var data = google.visualization.arrayToDataTable([
        ['Satisfaction', 'Value'],
        ['', result]
      ]);

      var options = {
        width: 110, height: 110,
        greenFrom: 0, greenTo: result,
        yellowFrom: result, yellowTo: 100,
        max: 100,
        minorTicks: 0,
        majorTicks: [0,100]
      };

      var chart = new google.visualization.Gauge(document.getElementById('gauge_div'));

      chart.draw(data, options);

    } */
  }


  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  // getData(lang);

  getData(lang: string) {
    // let langID = 0;
    // if (lang === 'ms') {
    //     langID = 2;
    // }else {
    //     langID = 1;
    // }

    return this.http.get(this.announcementUrl + '?language=' + this.languageId)
      .map(res => res.json())
      .subscribe(data => {
          //
          this.announcementData = data.contentCategoryResource.results[0];

          setTimeout(() => {
            this.isInitialized = true;
          }, 500);
          //
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
          this.loading = false;

        });
  }

  getCalendarData(lang: string) {
    let calArr = [];
    let dDay1;
    let dMonth1;
    let eTitle1;
    let dDay2;
    let dMonth2;
    let eTitle2;
    let currDate = this.date.toISOString();
    let currMonth = currDate.substr(0, 7);

    //return this.http.get(this.calendarUrl + '?language='+this.languageId+'&keyword='+currMonth+'&notExpired=false&sort=id,DESC')
    return this.http.get(this.calendarUrl + '/month?sort=eventStart,asc&language=' + this.languageId) //+ '?language='+this.languageId+'&keyword='+currMonth+'&notExpired=false&sort=id,DESC')
      .map(res => res.json())
      .subscribe(data => {

          /*if(data.list.length != 0) {
              dDay1 = this.datePipe.transform(data.list[0].eventStart, 'dd');
              dMonth1 = this.datePipe.transform(data.list[0].eventStart, 'MMMM');
              eTitle1 = data.list[0].eventName;

              if(data.list.length >= 2) {
                  dDay2 = this.datePipe.transform(data.list[1].eventStart, 'dd');
                  dMonth2 = this.datePipe.transform(data.list[1].eventStart, 'MMMM');
                  eTitle2 = data.list[1].eventName;
                  calArr.push({"day":dDay2,"month":dMonth2,"title":eTitle2})
              }

              calArr.push({"day":dDay1,"month":dMonth1,"title":eTitle1})

              this.calendarData = calArr;
          }*/
          calArr = [];
          for (let i = 0; i < data.list.length; i++) {
            if ((i + 1) % 2 !== 0) {
              dDay1 = this.datePipe.transform(data.list[i].eventStart, 'dd');
              dMonth1 = this.datePipe.transform(data.list[i].eventStart, 'MMMM');
              eTitle1 = data.list[i].eventName;
              if (data.list[i + 1]) {
                dDay2 = this.datePipe.transform(data.list[i + 1].eventStart, 'dd');
                dMonth2 = this.datePipe.transform(data.list[i + 1].eventStart, 'MMMM');
                eTitle2 = data.list[i + 1].eventName;
              } else {
                dDay2 = null;
                dMonth2 = null;
                eTitle2 = null;
              }
              calArr.push({
                "day1": dDay1,
                "month1": dMonth1,
                "title1": eTitle1,
                "day2": dDay2,
                "month2": dMonth2,
                "title2": eTitle2
              });
            }

          }
          this.calendarData = calArr;
          console.log(this.calendarData);
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
          this.loading = false;

        });
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

  triggerAnnouncementAll(id1, lang) {
    // if (lang === 'ms') {
    //     lang = 2;
    // }

    // if (lang === 'en') {
    //     lang = 1;
    // }

    this.route.paramMap
      .switchMap((params: ParamMap) =>
        this.navService.getContentUrl(id1, this.languageId))
      .subscribe(resAllAnnounce => {
          this.announceRes = resAllAnnounce;
          // convert object to array
          // const temp1 = this.announceRes[0];
          // const temp = Object.keys(temp1).map(key => temp1[key]);
          // this.announces = temp;

          this.announces = resAllAnnounce;
          this.breadcrumb = this.breadcrumbService.getBreadcrumb();
          this.isValid = this.breadcrumbService.isValid = true;
          this.breadcrumb = this.breadcrumb.name = '';
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
          this.loading = false;

        });
  }

  getDetailAnnounce(id0, id, childid?) {
    if (childid) {

    } else {

    }

    this.triggerAnnouncementAll(id, this.languageId);
    this.router.navigate(['content', id]);
    event.preventDefault();
  }


  conmonthToMalay

  protected readonly Date = Date;
}



// WEBPACK FOOTER //
// ./src/app/announcementbox/announcementbox.component.ts